import { render } from "./AiReportDetailContainer.vue?vue&type=template&id=2baf7fee&scoped=true&ts=true"
import script from "./AiReportDetailContainer.vue?vue&type=script&lang=ts"
export * from "./AiReportDetailContainer.vue?vue&type=script&lang=ts"

import "./AiReportDetailContainer.vue?vue&type=style&index=0&id=2baf7fee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baf7fee"]])

export default __exports__